import { Subject } from 'rxjs';
import { VmpFieldType, VmpSelectionType } from '../enums';

// noinspection JSUnusedGlobalSymbols
export class ViewModelProperty<T = any | undefined> {
  public fieldName = '';
  public caption = '';
  public infoText = '';
  public fieldType: VmpFieldType = VmpFieldType.Unspecified;
  public fieldLen = 0;
  public listFunction = '';
  public valueList: string[] = [];
  public selectionType: VmpSelectionType = VmpSelectionType.None;
  public initialValue: any = undefined;
  public displayValue: any = undefined;
  public required = false;
  public readOnly = false;
  public order = 0;
  public groupName = '';
  public subGroupName = '';
  public loading = false;
  public style = '';

  private _value?: T = undefined;
  public valueChange: Subject<any> = new Subject<any>();

  public get value(): T | undefined {
    return this._value;
  }

  public set value(newValue: T | undefined) {
    if (this._value == newValue) {
      return;
    }
    this._value = newValue;
    this.valueChange.next(newValue);
  }
}
